export default function initTranslationsMKD() {
  const translationsMKD = [
    {
      key: 'Type',
      value: 'Type'
    },
    {
      key: 'Online Prämienzahlung',
      value: 'Online Prämienzahlung'
    },
    {
      key: 'Policy number',
      value: 'Broj na polisa'
    },
    {
      key: 'Date of birth',
      value: 'Datum na raganje'
    },
    {
      key: 'Name and Surname',
      value: 'Ime i Prezime'
    },
    {
      key: 'Client Address',
      value: 'Adresa'
    },
    {
      key: 'Client City',
      value: 'City'
    },
    {
      key: 'Client Postal Code',
      value: 'ZIP kod'
    },
    {
      key: 'Client Country',
      value: 'Country'
    },
    {
      key: 'Client Telephone number',
      value: 'Telephone'
    },
    {
      key: 'Email',
      value: 'Email'
    },
    {
      key: 'Premium value',
      value: 'Otvoren del na Premija'
    },
    {
      key: 'Field for Premium Payment',
      value: 'Pole za vnes na Premija za plakanje'
    },
    {
      key: 'Offer number',
      value: 'Offer number'
    }
  ];

  window.reactTranslations = window.reactTranslations || [];
  window.reactTranslations.push(...translationsMKD);
}
